import React, { useEffect, useRef, useCallback, useMemo, useState } from "react";
import { graphic } from "../../lib/graphic/Graphic";
import { graphicEvents, ON_SELECT_PIT, ON_SELECT_SEAT, ON_UNSELECT_SEAT } from "../../lib/graphic/GraphicEvents";
import { DataHelper } from "../../helpers/data.helper";
import { RowService } from "../../lib/graphic/entity/row/RowService";
import { TextService } from "../../lib/graphic/entity/text/TextService";
import { TYPES } from "../../lib/graphic/EntityManager";
import { PickerEditionMode } from "../../lib/graphic/editions/picker/PickerEditionMode";
import { PanEditionMode } from "../../lib/graphic/editions/pan/PanEditionMode";

import './Map.scss'
import { PitService } from "../../lib/graphic/entity/pit/PitService";
import { MapTools } from "./MapTools";
import { ImageService } from "../../lib/graphic/entity/image/ImageService";
import { Entity } from "../../lib/graphic/entity/Entity";
import { Picker } from "../../lib/graphic/editions/picker/Picker";

/**
 * @param header
 * @param footer
 * @param graphicEntities
 * @param categories
 * @param bookings
 * @param onGraphicInitialized
 * @param onUnselectSeat
 * @param onSelectSeat
 * @param onSelectPit
 * @param validateBooking
 * @returns {*}
 * @constructor
 */
export function Map({
    header,
    footer,
    graphicEntities,
    categories,
    bookings,
    onBeforeInitialization = null,
    onAfterInitialization = null,
    pickerOptions = {
        mode: Picker.MODE_BOOKING
    },
    onSelectSeat,
    onUnselectSeat,
    onSelectPit,
    assetsPath,
    validateBooking = booking => booking.statusCode === 0,
    disableBooking = booking => booking.statusCode === 2
}) {
    const graphicElement = useRef(null);

    const setGraphic = async () => {

        // Pour laisser le temps au loader de s'afficher
        await new Promise(next => setTimeout(() => next(), 200));

        graphic.init(graphicElement.current, { assetsPath, backgroundColor: 0xFFFFFF }, () => {
            // @todo: mettre l'initialisation des pits ici pour afficher correctement l'icon
            // @todo: v�rifier le fait qu'on change un si�ge de cat�gorie si cette cat�gorie n'est pas r�servable en front est-ce qie �a fonctionne toujours ?
        });

        if (graphicEntities.rows) {
            const rowsProps = graphicEntities.rows.map(row => DataHelper.rowFromAPIToWidget(row, categories));
            RowService.upsertFromProps(rowsProps);
        }
        if (graphicEntities.texts) {
            const textsProps = graphicEntities.texts.map(text => DataHelper.textFromAPIToWidget(text));
            TextService.upsertFromProps(textsProps);
        }
        if (graphicEntities.pits) {
            const pitsProps = graphicEntities.pits.map(pit => DataHelper.pitFromAPIToWidget(pit, categories));
            PitService.upsertFromProps(pitsProps);
        }
        if (graphicEntities.image) {
            const imageProps = DataHelper.imageFromAPIToWidget(graphicEntities.image);
            ImageService.upsertFromProps([imageProps]);
        }

        const disabled = [];
        bookings.forEach(booking => {
            if (booking.rowId) {
                const row = graphic.entityManager.get(TYPES.ROW, booking.rowId);
                if (row.isEnable && !validateBooking(booking)) {
                    const state = disableBooking(booking)
                        ? Entity.GRAPHIC_STATE_DISABLED
                        : Entity.GRAPHIC_STATE_BOOKED;
                    row.disableGraphicItem(booking.seatIndex, state);
                    disabled.push(row.graphicItems[booking.seatIndex]);
                }
                booking.categoryId = booking.categoryId || row.category.id
                row.setSeatCategory({ index: booking.seatIndex }, booking.categoryId, categories);
            }
            if (booking.pitId) {
                const pit = graphic.entityManager.get(TYPES.PIT, booking.pitId);
                if ((!pit.isEnable || booking.status == 'BOOKED') && !validateBooking(booking)) {
                    pit.disable();
                    disabled.push(pit.graphicItems[0]);
                }
            }
        });

        if (onBeforeInitialization) onBeforeInitialization();

        if (pickerOptions.mode === Picker.MODE_STATUS) {
            pickerOptions.itemsSelected = disabled;
            graphic.entityManager.forEach(TYPES.PIT, pit => pit.disable());
        }

        graphic.center();
        graphic.setEditionMode(
            new PickerEditionMode(pickerOptions),
            new PanEditionMode()
        );

        if (onAfterInitialization) onAfterInitialization();

    };

    const unsetGraphic = useCallback(() => {
        graphic.unsetEditionMode();
        graphic.destroy();
    }, []);

    useEffect(() => {
        if (!graphicEntities) return;
        setGraphic();
        return () => unsetGraphic();
    }, [graphicEntities]);

    useEffect(() => {
        graphicEvents.on(ON_SELECT_SEAT, onSelectSeat);
        return () => graphicEvents.remove(ON_SELECT_SEAT, onSelectSeat);
    });

    useEffect(() => {
        graphicEvents.on(ON_UNSELECT_SEAT, onUnselectSeat);
        return () => graphicEvents.remove(ON_UNSELECT_SEAT, onUnselectSeat);
    });

    useEffect(() => {
        graphicEvents.on(ON_SELECT_PIT, onSelectPit);
        return () => graphicEvents.remove(ON_SELECT_PIT, onSelectPit)
    });

    return (
        <div className={"Map-container"}>
            <div className="Map-header">
                <MapTools/>
                {header}
            </div>
            <div className={'Map'} ref={graphicElement}/>
            <div className="Map-footer">{footer}</div>
        </div>
    )
}